export const US_PHONE_NUMBER_QUERY_KEYS = {
    all: "available-us-phone-numbers",
    byAreaCode: (areaCode: string) => ["available-us-phone-numbers", areaCode],
    popular: () => ["available-us-phone-numbers", "popular"],
}

export const US_PHONE_NUMBER_PRICING_QUERY_KEYS = {
    all: ["us-phone-number-pricing"] as const,

    byPhoneNumber: (phoneNumber: string) =>
        [...US_PHONE_NUMBER_PRICING_QUERY_KEYS.all, phoneNumber] as const,
};
